import { buildLinkedEntityString } from "./custom-report-card/custom-report-card";
import { groupByOptions } from "./dataset-sidebar";
import LimitedTags, { TagItem } from "./limited-tags";

function DatasetConfigTags({ datasetConfig }: { datasetConfig: any }) {
  const tags: TagItem[] = [];

  const groupByTag = groupByOptions.find(
    (option) => option.value === datasetConfig?.groupByField
  )?.tag;

  tags.push({
    tag: groupByTag || "No Grouping",
    value: datasetConfig?.groupByField
  });

  const linkedEntityString = buildLinkedEntityString(
    datasetConfig?.linkedEntity
  );

  tags.push({
    tag: linkedEntityString,
    value: linkedEntityString
  });

  // tags.push({
  //   tag: datasetConfig?.additional_config?.exclude_wf_complete
  //     ? CustomReportsI18n.doesNotIncludeDeliveredMaterials
  //     : CustomReportsI18n.includesDeliveredMaterials,
  //   value: "include_workflow_complete"
  // });

  return (
    <div data-testid="dataset-config-tags">
      <LimitedTags reportId="dataset-config-tags" tags={tags} maxVisible={2} />
    </div>
  );
}

export default DatasetConfigTags;
